export const adaptProductForCard = (product) => {
  const id = product._id?.$oid || product._id;
  const _id = id;

  // Keep full color object so the cart can use color._id for uniqueness
  const variants = (product.variants || []).map((v) => ({
    color: {
      _id: v.color?._id?.$oid || v.color?._id,
      name: v.color?.name,
      hex: v.color?.hex,
    },
    images: v.images || [],
    sizes: v.sizes || [],
  }));

  const firstVariant = variants[0];
  const image = firstVariant?.images?.[0]?.url || null;
  const colors = variants.map((v) => v.color?.hex).filter(Boolean);

  // Aggregate stock across ALL variants for a fallback "all sizes" view
  const stockBySize = new Map();
  product.variants?.forEach((variant) => {
    variant.sizes?.forEach(({ size, stock }) => {
      stockBySize.set(size, (stockBySize.get(size) || 0) + stock);
    });
  });

  const sizesAvailable = [];
  const sizesNotify = [];
  stockBySize.forEach((stock, size) => {
    if (stock > 0) sizesAvailable.push(size);
    else sizesNotify.push(size);
  });

  if (sizesAvailable.length === 0 && sizesNotify.length === 0) {
    (product.availableSizes || []).forEach((s) => sizesAvailable.push(s));
  }

  return {
    id,
    _id,
    title: product.name,
    image,
    slug: product.slug,
    price: product.basePrice,
    originalPrice: product.originalPrice || null,
    brand: product.brand || "",
    currency: product.currency || "KES",
    colors,
    variants,
    tag: product.brand,
    tone: product.occassion,
    rating: product.rating ?? null,
    count: product.reviewCount ?? null,
    badge: product.sold > 100 ? { label: "Bestseller", tone: "warning" } : null,
    sizesAvailable,
    sizesNotify,
  };
};
// src/utils/recentlyViewed.js

export const trackRecentlyViewed = (productId) => {
  if (!productId) return;

  try {
    const stored = JSON.parse(localStorage.getItem("recentlyViewed") || "[]");
    const filtered = stored.filter((id) => id !== productId);
    const updated = [productId, ...filtered];
    const trimmed = updated.slice(0, 10);
    localStorage.setItem("recentlyViewed", JSON.stringify(trimmed));
  } catch (error) {
    console.error("Failed to track recently viewed:", error);
  }
};

export const getRecentlyViewed = () => {
  try {
    return JSON.parse(localStorage.getItem("recentlyViewed") || "[]");
  } catch {
    return [];
  }
};

export const removeFromRecentlyViewed = (productId) => {
  try {
    const stored = JSON.parse(localStorage.getItem("recentlyViewed") || "[]");
    const updated = stored.filter((id) => id !== productId);
    localStorage.setItem("recentlyViewed", JSON.stringify(updated));
    return updated;
  } catch {
    return [];
  }
};

export const clearRecentlyViewed = () => {
  try {
    localStorage.removeItem("recentlyViewed");
  } catch (error) {
    console.error("Failed to clear recently viewed:", error);
  }
};
export const getPaginationRange = (current, total) => {
  const delta = 2; // number of pages to show on each side of current
  const range = [];
  const rangeWithEllipsis = [];

  // Always include first page
  range.push(1);

  // Build the central window: from current - delta to current + delta
  for (
    let i = Math.max(2, current - delta);
    i <= Math.min(total - 1, current + delta);
    i++
  ) {
    range.push(i);
  }

  // Always include last page
  if (total > 1) range.push(total);

  // Remove duplicates and sort
  const unique = [...new Set(range)].sort((a, b) => a - b);

  // Insert ellipsis where gaps exist
  for (let i = 0; i < unique.length; i++) {
    if (i > 0 && unique[i] - unique[i - 1] > 1) {
      rangeWithEllipsis.push("ellipsis");
    }
    rangeWithEllipsis.push(unique[i]);
  }

  return rangeWithEllipsis;
};
